import { render, staticRenderFns } from "./add-update.vue?vue&type=template&id=1e608a80"
import script from "./add-update.vue?vue&type=script&lang=js"
export * from "./add-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports